(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('DocumentoDetailController', DocumentoDetailController);

    DocumentoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Documento', 'Norma'];

    function DocumentoDetailController($scope, $rootScope, $stateParams, previousState, entity, Documento, Norma) {
        var vm = this;

        vm.documento = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('sgnmrApp:documentoUpdate', function(event, result) {
            vm.documento = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
